
export enum KeyMetricListTypes {
	CALCULATION = 'calculation',
	GROUPING = 'grouping',
	CALCULATION_SERIES = '_calculation_series'
}
